export default __webpack_public_path__ + "static/media/activate-2.70955588.png";